(function (angular) {
    'use strict';

    /**
     * @ngdoc object
     * @name SMART2
     * @description
     * {@link https://angularjs.org/ AngularJS} project module of SMART 2.0 product
     * by {@link http://www.gep.com/ GEP} 
     */
    angular.module('SMART2')
        .config(['$animateProvider', '$translateProvider', '$controllerProvider', 'APPCONSTANTS', '$provide', '$httpProvider', 'CONSTANTS', configFunc])
        .run(['$rootScope', '$sce', '$timeout', '$document', '$interval', '$translate', 'APPCONSTANTS', runFunc]);

    /**
     * @ngdoc method
     * @name configFunc
     * @methodOf SMART-Public.config
     * @description
     * The method of the SMART2 config. This config handles any other configurations of the application other than routing.
     *
     * @param {Object} $animateProvider Default implementation of $animate that doesn't perform any animations, instead just synchronously performs DOM updates and resolves the returned runner promise. 
     */
    function configFunc($animateProvider, $translateProvider, $controllerProvider, APPCONSTANTS, $provide, $httpProvider, CONSTANTS) {
      
        angular.module('SMART2').controllerProvider = $controllerProvider;
        angular.module('SMART2').provide = $provide;

        APPCONSTANTS.userPreferences = userInfo;
        APPCONSTANTS.userPreferences.constantURLAndQueryStringValue = APPCONSTANTS.constantURLAndQueryStringValue;
        if (typeof bpcForNewDocument !== 'undefined') {
            APPCONSTANTS.userPreferences.constantURLAndQueryStringValue.encryptedBlankDocument = bpcForNewDocument;
        }
        APPCONSTANTS.userPreferences.UserBasicDetails.UserName = APPCONSTANTS.userPreferences.UserBasicDetails.PartnerName;
        APPCONSTANTS.userPreferences.constantURLAndQueryStringValue.encryptedBPC = APPCONSTANTS.userPreferences.EncryptedParamBPC;
        APPCONSTANTS.userPreferences.encryptedBPC = APPCONSTANTS.userPreferences.EncryptedParamBPC;
        APPCONSTANTS.userPreferences.SMART2DocTypes = "1";
        if (navigator.userAgent.indexOf("Trident") > -1) {
            window.location.origin = APPCONSTANTS.userPreferences.URLs.AppURL;
        }
        userInfo = undefined;       
        $translateProvider.translations(APPCONSTANTS.userPreferences.UserBasicDetails.Culture, Resources);
        $translateProvider.preferredLanguage(APPCONSTANTS.userPreferences.UserBasicDetails.Culture);      
        $httpProvider.interceptors.push('httpErrorHandlerInterceptor');
    }

    function runFunc($rootScope, $sce, $timeout, $document, $interval, $translate, APPCONSTANTS) {
        APPCONSTANTS.userPreferences.LogoImagePartialPath = APPCONSTANTS.userPreferences.URLs.ContentURL + "cumuluscontent/logo/";
        APPCONSTANTS.userPreferences.BGImagePartialPath = APPCONSTANTS.userPreferences.URLs.ContentURL + 'smartcontent/workspace/shared/theme/user/background/';
        APPCONSTANTS.userPreferences.LogoImageURL = APPCONSTANTS.userPreferences.LogoImagePartialPath + APPCONSTANTS.userPreferences.UserBasicDetails.ClientID + '_logo.png';
        var defaultImg = APPCONSTANTS.userPreferences.BGImagePartialPath + 'Smart_bg.jpg', UserImg = APPCONSTANTS.userPreferences.BGImagePartialPath + APPCONSTANTS.userPreferences.UserBasicDetails.ClientID + '_bg.jpg';
        APPCONSTANTS.userPreferences.BGImageURL = defaultImg;
        $rootScope.logoImage = $sce.getTrustedResourceUrl($sce.trustAsResourceUrl(APPCONSTANTS.userPreferences.LogoImageURL));
        $rootScope.addAnnouncementPopup = false;
        $rootScope.bookmarkPopup = false;
        $rootScope.loaderPosition = false;
        $rootScope.showAddOption = true;
        $rootScope.bookmarkallData = [];
        $rootScope.isPageWithoutImage = false;
        $rootScope.p2ploader = true;
        $rootScope.validateBookmarkName = false;
        $rootScope.validateBookmarkNamedesc = false;
        $rootScope.typeofAnnouncement = "INTERNAL";
        $rootScope.showSniffing = true;
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, options) {
            if (angular.element(".lean-overlay")) {
                angular.element(".lean-overlay").not(".notification-massage .lean-overlay").fadeOut();
            }
            if (fromState.name == "platform") {
                $('body').removeClass('is-overflowHidden');
            }
            if (toState.name == "platform") {
                $('body').addClass('is-overflowHidden');
            }
        });
        $rootScope.pageTitle = APPCONSTANTS.userPreferences.UserBasicDetails.PartnerName.toUpperCase() + " | " + $translate.instant('public_events');
    }
})(angular);
